import { format } from "date-fns";
import * as Yup from "yup";
import { formatDate } from "./task-form.helpers.js";
import { Category } from "./task-form.types.js";
import "date-fns/locale";
const initialValues = {
  description: "",
  category: Category.APPOINTMENT_HANDLING,
  employeeReferenceId: "",
  patientReferenceId: "",
  important: false,
  dueDateSwitch: "off",
  dueDate: /* @__PURE__ */ new Date()
};
const schema = Yup.object().shape({
  description: Yup.string().required("Please add a description"),
  category: Yup.string().required("Please select a category"),
  employeeReferenceId: Yup.string().required("Please select an employee")
});
const filterFormData = (form) => {
  const { dueDateSwitch, dueDate } = form;
  return {
    ...form,
    dueDateSwitch,
    dueDate: dueDateSwitch === "off" ? null : format(dueDate, "yyyy-MM-dd")
  };
};
const parseFormData = (data) => {
  const { dueDate, ...form } = data;
  return {
    ...form,
    dueDate: dueDate ? formatDate(dueDate) : null,
    dueDateSwitch: dueDate ? "on" : "off"
  };
};
export {
  filterFormData,
  initialValues,
  parseFormData,
  schema
};
